// // import React, { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";
// // import "./HlcCalculator.css";
// // import { PRODUCT_DATA } from "../data/productData";

// // // Default demo image
// // import demoImage from "../assets/products/1.png";

// // const TREE = {};

// // PRODUCT_DATA.forEach((item) => {
// //   if (!TREE[item.main]) TREE[item.main] = {};
// //   if (!TREE[item.main][item.sub]) TREE[item.main][item.sub] = {};
// //   if (!TREE[item.main][item.sub][item.product]) {
// //     TREE[item.main][item.sub][item.product] = [];
// //   }
// //   TREE[item.main][item.sub][item.product].push(item);
// // });

// // export default function HlcCalculator() {
// //   /* ---------------- DROPDOWN STATES ---------------- */
// //   const [mainCategory, setMainCategory] = useState("");
// //   const [subCategory, setSubCategory] = useState("");
// //   const [product, setProduct] = useState("");
// //   const [wattage, setWattage] = useState("");

// //   const [subList, setSubList] = useState([]);
// //   const [productsList, setProductsList] = useState([]);
// //   const [wattList, setWattList] = useState([]);

// //   const [selectedItem, setSelectedItem] = useState(null);

// //   /* ---------------- CALCULATOR STATES ---------------- */
// //   const [currentW, setCurrentW] = useState(60);
// //   const [hours, setHours] = useState(5);
// //   const [bulbs, setBulbs] = useState(6);
// //   const [rate, setRate] = useState(55);

// //   const [monthlySaving, setMonthlySaving] = useState("PKR —");
// //   const [yearlySaving, setYearlySaving] = useState("PKR —");
// //   const [energyReduced, setEnergyReduced] = useState("— kWh / month");

// //   /* ---------------- MAIN CATEGORY CHANGE ---------------- */
// //   useEffect(() => {
// //     if (!mainCategory) {
// //       setSubList([]);
// //       setSubCategory("");
// //       setProduct("");
// //       setWattage("");
// //       setProductsList([]);
// //       setWattList([]);
// //       setSelectedItem(null);
// //       return;
// //     }

// //     setSubList(Object.keys(TREE[mainCategory]));
// //     setSubCategory("");
// //     setProduct("");
// //     setWattage("");
// //     setProductsList([]);
// //     setWattList([]);
// //     setSelectedItem(null);
// //   }, [mainCategory]);

// //   /* ---------------- SUB CATEGORY CHANGE ---------------- */
// //   useEffect(() => {
// //     if (!mainCategory || !subCategory) {
// //       setProductsList([]);
// //       setProduct("");
// //       setWattage("");
// //       setWattList([]);
// //       setSelectedItem(null);
// //       return;
// //     }

// //     setProductsList(Object.keys(TREE[mainCategory][subCategory]));
// //     setProduct("");
// //     setWattage("");
// //     setWattList([]);
// //     setSelectedItem(null);
// //   }, [mainCategory, subCategory]);

// //   /* ---------------- PRODUCT CHANGE ---------------- */
// //   useEffect(() => {
// //     if (!mainCategory || !subCategory || !product) {
// //       setWattList([]);
// //       setWattage("");
// //       setSelectedItem(null);
// //       return;
// //     }

// //     const watts = TREE[mainCategory][subCategory][product].map(
// //       (i) => i.modelLabel
// //     );

// //     setWattList([...new Set(watts)]);
// //     setWattage("");
// //     setSelectedItem(null);
// //   }, [mainCategory, subCategory, product]);

// //   /* ---------------- WATT / MODEL CHANGE ---------------- */
// //   useEffect(() => {
// //     if (!mainCategory || !subCategory || !product || !wattage) {
// //       setSelectedItem(null);
// //       return;
// //     }

// //     const found = TREE[mainCategory][subCategory][product].find(
// //       (i) => i.modelLabel === wattage
// //     );

// //     setSelectedItem(found || null);
// //   }, [mainCategory, subCategory, product, wattage]);

// //   /* ---------------- CALCULATE SAVINGS ---------------- */
// //   const calculateSavings = () => {
// //     if (!selectedItem || selectedItem.watt == null) {
// //       alert("Selected product is not applicable for savings calculation.");
// //       return;
// //     }

// //     if (!currentW || !hours || !bulbs || !rate) {
// //       alert("Please fill all fields.");
// //       return;
// //     }

// //     const ledWatt = selectedItem.watt;

// //     const currentUnits = (currentW * bulbs * hours * 30) / 1000;
// //     const ledUnits = (ledWatt * bulbs * hours * 30) / 1000;

// //     const savedUnits = Math.max(currentUnits - ledUnits, 0);

// //     const monthly = Math.round(savedUnits * rate);
// //     const yearly = monthly * 12;

// //     setMonthlySaving(`PKR ${monthly.toLocaleString()}`);
// //     setYearlySaving(`PKR ${yearly.toLocaleString()}`);
// //     setEnergyReduced(`${savedUnits.toFixed(1)} kWh / month`);
// //   };

// //   return (
// //     <section id="hlc-savings-section" className="full-bg-section bg-brand">
// //       <div className="section-inner">
// //         {/* Heading */}
// //         <header className="ec-head">
// //           <span className="ec-head__eyebrow">Savings Calculator</span>
// //           <h2>See Your Lighting Savings</h2>
// //           <p>
// //             HLC LEDs wattage kam, brightness zyada. Abhi estimate karein kitni
// //             monthly aur yearly bachhat ho sakti hai.
// //           </p>
// //         </header>

// //         {/* MAIN GRID */}
// //         <div className="ec-grid">
// //           {/* LEFT FORM */}
// //           <aside className="ec-form">
// //             <div className="ec-form__top">
// //               <h3 className="ec-panel-title">Select Your Product</h3>
// //               <p className="ec-panel-sub">
// //                 Category, product aur watt/model select karein. Selected wattage
// //                 automatically calculation men use hoga.
// //               </p>
// //             </div>

// //             {/* MAIN CATEGORY */}
// //             <div className="ec-field">
// //               <label>Select Main Category</label>
// //               <select
// //                 value={mainCategory}
// //                 onChange={(e) => setMainCategory(e.target.value)}
// //               >
// //                 <option value="">Choose main category</option>
// //                 {Object.keys(TREE).map((main) => (
// //                   <option key={main} value={main}>
// //                     {main}
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>

// //             {/* SUB CATEGORY */}
// //             {subList.length > 0 && (
// //               <div className="ec-field">
// //                 <label>Select Sub Category</label>
// //                 <select
// //                   value={subCategory}
// //                   onChange={(e) => setSubCategory(e.target.value)}
// //                 >
// //                   <option value="">Choose sub category</option>
// //                   {subList.map((sub) => (
// //                     <option key={sub} value={sub}>
// //                       {sub}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>
// //             )}

// //             {/* PRODUCT */}
// //             {productsList.length > 0 && (
// //               <div className="ec-field">
// //                 <label>Select Product</label>
// //                 <select
// //                   value={product}
// //                   onChange={(e) => setProduct(e.target.value)}
// //                 >
// //                   <option value="">Choose product</option>
// //                   {productsList.map((p) => (
// //                     <option key={p} value={p}>
// //                       {p}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>
// //             )}

// //             {/* WATT / MODEL */}
// //             {wattList.length > 0 && (
// //               <div className="ec-field">
// //                 <label>Select Watt / Model</label>
// //                 <select
// //                   value={wattage}
// //                   onChange={(e) => setWattage(e.target.value)}
// //                 >
// //                   <option value="">Choose watt / model</option>
// //                   {wattList.map((w) => (
// //                     <option key={w} value={w}>
// //                       {w}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>
// //             )}

// //             {/* PRODUCT SUMMARY */}
// //             {selectedItem && (
// //               <div className="ec-product-spec">
// //                 <div className="ec-product-spec__inner">
// //                   <div className="ec-spec-row">
// //                     <span className="ec-spec-label">Main Category</span>
// //                     <span className="ec-spec-value">{selectedItem.main}</span>
// //                   </div>

// //                   <div className="ec-spec-row">
// //                     <span className="ec-spec-label">Sub Category</span>
// //                     <span className="ec-spec-value">{selectedItem.sub}</span>
// //                   </div>

// //                   <div className="ec-spec-row">
// //                     <span className="ec-spec-label">Product</span>
// //                     <span className="ec-spec-value">{selectedItem.product}</span>
// //                   </div>

// //                   <div className="ec-spec-row">
// //                     <span className="ec-spec-label">Watt / Model</span>
// //                     <span className="ec-spec-value">
// //                       {selectedItem.modelLabel}
// //                     </span>
// //                   </div>

// //                   {selectedItem.pinType && (
// //                     <div className="ec-spec-row">
// //                       <span className="ec-spec-label">Pin Type</span>
// //                       <span className="ec-spec-value">
// //                         {selectedItem.pinType}
// //                       </span>
// //                     </div>
// //                   )}

// //                   {selectedItem.colour && (
// //                     <div className="ec-spec-row">
// //                       <span className="ec-spec-label">Light Colour</span>
// //                       <span className="ec-spec-value">
// //                         {selectedItem.colour}
// //                       </span>
// //                     </div>
// //                   )}
// //                 </div>

// //                 <p className="ec-product-spec__note">
// //                   Selected wattage will be used automatically in the savings
// //                   calculation.
// //                 </p>
// //               </div>
// //             )}

// //             <div className="ec-divider"></div>

// //             <div className="ec-form__top ec-form__top--small">
// //               <h3 className="ec-panel-title">Usage Details</h3>
// //             </div>

// //             {/* CALCULATOR INPUTS */}
// //             <div className="ec-field">
// //               <label>Current Bulb Wattage (W)</label>
// //               <input
// //                 type="number"
// //                 min="1"
// //                 value={currentW}
// //                 onChange={(e) => setCurrentW(+e.target.value)}
// //               />
// //             </div>

// //             <div className="ec-row">
// //               <div className="ec-field">
// //                 <label>Daily Usage (hours)</label>
// //                 <input
// //                   type="number"
// //                   min="1"
// //                   value={hours}
// //                   onChange={(e) => setHours(+e.target.value)}
// //                 />
// //               </div>

// //               <div className="ec-field">
// //                 <label>Bulbs Count</label>
// //                 <input
// //                   type="number"
// //                   min="1"
// //                   value={bulbs}
// //                   onChange={(e) => setBulbs(+e.target.value)}
// //                 />
// //               </div>
// //             </div>

// //             <div className="ec-field">
// //               <label>Electricity Cost (PKR / kWh)</label>
// //               <input
// //                 type="number"
// //                 min="1"
// //                 value={rate}
// //                 onChange={(e) => setRate(+e.target.value)}
// //               />
// //             </div>

// //             <button className="ec-btn" onClick={calculateSavings} type="button">
// //               Calculate Savings
// //             </button>

// //             <p className="ec-note">
// //               Tip: Values ko apne ghar, shop ya office ke hisaab se adjust
// //               karein.
// //             </p>
// //           </aside>

// //           {/* MIDDLE STATS */}
// //           <section className="ec-stats" aria-label="Savings Results">
// //             <div className="ec-stats__grid">
// //               <div className="ec-card ec-card--highlight">
// //                 <span className="ec-label">Monthly Saving</span>
// //                 <strong className="ec-value">{monthlySaving}</strong>
// //               </div>

// //               <div className="ec-card ec-card--highlight">
// //                 <span className="ec-label">Yearly Saving</span>
// //                 <strong className="ec-value">{yearlySaving}</strong>
// //               </div>

// //               <div className="ec-card ec-card--wide">
// //                 <span className="ec-label">Energy Reduced</span>
// //                 <strong className="ec-value">{energyReduced}</strong>
// //               </div>
// //             </div>

// //             <div className="ec-result-note">
// //               Estimated savings depend on selected LED wattage, usage hours,
// //               bulb quantity and electricity rate.
// //             </div>
// //           </section>

// //           {/* RIGHT PROMO */}
// //           <figure className="ec-promo">
// //             <div className="ec-promo__media">
// //               <img
// //                 src={selectedItem?.image || demoImage}
// //                 alt={selectedItem ? `${selectedItem.product} ${selectedItem.modelLabel}` : "HLC LED Product"}
// //               />
// //             </div>

// //             <figcaption className="ec-promo__content">
// //               <h3>Switch to Efficient HLC LEDs</h3>
// //               <p>
// //                 Choose better brightness with lower electricity consumption for
// //                 homes, offices and commercial projects.
// //               </p>

// //               <Link to="/shop" className="ec-cta">
// //                 Shop Recommended LEDs
// //               </Link>
// //             </figcaption>
// //           </figure>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // }

// // import React, { useMemo, useState } from "react";
// // import { Link } from "react-router-dom";
// // import { PRODUCT_DATA } from "../data/productData";

// // // Default demo image
// // import demoImage from "../assets/products/1.png";
// // import Navbar from "../components/Navbar";
// // import HlcFooter from "../components/HlcFooter";

// // export default function Calculator() {
// //   /* ---------------- TREE BUILD ---------------- */
// //   const TREE = useMemo(() => {
// //     const tree = {};

// //     PRODUCT_DATA.forEach((item) => {
// //       const sub = item.main; // because your new frontend starts from "sub category" directly
// //       const product = item.product || item.sub || "";
// //       const modelLabel = item.modelLabel || "";
// //       const watt = item.watt ?? null;

// //       if (!tree[sub]) tree[sub] = {};
// //       if (!tree[sub][product]) tree[sub][product] = [];
// //       tree[sub][product].push({
// //         ...item,
// //         sub,
// //         product,
// //         modelLabel,
// //         watt,
// //       });
// //     });

// //     return tree;
// //   }, []);

// //   /* ---------------- DROPDOWN STATES ---------------- */
// //   const [subCategory, setSubCategory] = useState("");
// //   const [product, setProduct] = useState("");
// //   const [wattage, setWattage] = useState("");

// //   const [selectedItem, setSelectedItem] = useState(null);

// //   /* ---------------- CALCULATOR STATES ---------------- */
// //   const [currentW, setCurrentW] = useState(60);
// //   const [hours, setHours] = useState(5);
// //   const [bulbs, setBulbs] = useState(6);
// //   const [rate, setRate] = useState(55);

// //   const [monthlySaving, setMonthlySaving] = useState("PKR —");
// //   const [yearlySaving, setYearlySaving] = useState("PKR —");
// //   const [energyReduced, setEnergyReduced] = useState("— kWh / month");

// //   /* ---------------- DROPDOWN DATA ---------------- */
// //   const subList = Object.keys(TREE);

// //   const productsList = subCategory ? Object.keys(TREE[subCategory] || {}) : [];

// //   const wattList =
// //     subCategory && product
// //       ? [
// //           ...new Set(
// //             (TREE[subCategory]?.[product] || []).map((item) => item.modelLabel)
// //           ),
// //         ]
// //       : [];

// //   /* ---------------- HANDLERS ---------------- */
// //   const handleSubChange = (e) => {
// //     const value = e.target.value;
// //     setSubCategory(value);
// //     setProduct("");
// //     setWattage("");
// //     setSelectedItem(null);
// //   };

// //   const handleProductChange = (e) => {
// //     const value = e.target.value;
// //     setProduct(value);
// //     setWattage("");
// //     setSelectedItem(null);

// //     const models = TREE[subCategory]?.[value] || [];
// //     if (models.length > 0) {
// //       const firstModel = models[0]?.modelLabel || "";
// //       setWattage(firstModel);

// //       const found = models.find((i) => i.modelLabel === firstModel);
// //       setSelectedItem(found || null);
// //     }
// //   };

// //   const handleWattChange = (e) => {
// //     const value = e.target.value;
// //     setWattage(value);

// //     const found = (TREE[subCategory]?.[product] || []).find(
// //       (i) => i.modelLabel === value
// //     );

// //     setSelectedItem(found || null);
// //   };

// //   /* ---------------- ANIMATION ---------------- */
// //   const animateCurrency = (setter, end) => {
// //     const start = 0;
// //     const duration = 500;
// //     const startTime = performance.now();

// //     function tick(now) {
// //       const p = Math.min((now - startTime) / duration, 1);
// //       const val = Math.round(start + (end - start) * p);
// //       setter(`PKR ${val.toLocaleString()}`);
// //       if (p < 1) requestAnimationFrame(tick);
// //     }

// //     requestAnimationFrame(tick);
// //   };

// //   /* ---------------- CALCULATE SAVINGS ---------------- */
// //   const calculateSavings = () => {
// //     if (!selectedItem) {
// //       alert("Please select sub category, product and watt/model first.");
// //       return;
// //     }

// //     if (selectedItem.watt == null) {
// //       alert("This product does not have a defined wattage for the calculator.");
// //       return;
// //     }

// //     if (!currentW || !hours || !bulbs || !rate) {
// //       alert("Please fill all fields.");
// //       return;
// //     }

// //     const LED = Number(selectedItem.watt);
// //     const W = Number(currentW);
// //     const hrs = Number(hours);
// //     const bulbCount = Number(bulbs);
// //     const unitRate = Number(rate);

// //     const cur = (W * bulbCount * hrs * 30) / 1000;
// //     const led = (LED * bulbCount * hrs * 30) / 1000;
// //     const save = Math.max(cur - led, 0);

// //     const monthly = Math.round(save * unitRate);
// //     const yearly = monthly * 12;

// //     animateCurrency(setMonthlySaving, monthly);
// //     animateCurrency(setYearlySaving, yearly);
// //     setEnergyReduced(`${save.toFixed(1)} kWh / month`);
// //   };

// //   return (
// //     <>
// //       <style>{`
// //         .full-bg-section{
// //           position:relative;
// //           left:50%;
// //           right:50%;
// //           margin-left:-50vw;
// //           margin-right:-50vw;
// //           width:100vw;
// //           overflow:hidden;
// //           padding:0;
// //            margin-top:60px
// //         }

// //         .bg-brand{
// //           background:linear-gradient(135deg,#9b1f6c 0%,#542757 45%,#35335b 100%);
// //           color:#fff;
// //         }

// //         .section-inner{
// //           max-width:1200px;
// //           margin:auto;
// //           padding:18px 18px 18px;
// //           box-sizing:border-box;
// //           font-family:"Open Sans",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// //         }

// //         #hlc-savings-section{
// //           min-height:auto;
// //         }

// //         @media (min-width:1025px){
// //           #hlc-savings-section{
// //             min-height:100vh;
// //             display:flex;
// //             align-items:center;
// //           }

// //           .section-inner{
// //             width:100%;
// //             padding:12px 18px;
// //           }
// //         }

// //         .ec-head{
// //           text-align:center;
// //           margin-bottom:12px;
// //         }

// //         .ec-head__eyebrow{
// //           display:inline-block;
// //           margin:0 0 4px;
// //           font-size:10px;
// //           font-weight:700;
// //           letter-spacing:.16em;
// //           text-transform:uppercase;
// //           color:rgba(255,255,255,.72);
// //         }

// //         .ec-head h2{
// //           font-size:clamp(22px,2.9vw,30px);
// //           line-height:1.05;
// //           margin:0 0 4px;
// //           font-weight:800;
// //           letter-spacing:-.02em;
// //         }

// //         .ec-head p{
// //           max-width:760px;
// //           margin:0 auto;
// //           font-size:12px;
// //           line-height:1.45;
// //           color:rgba(255,255,255,.84);
// //         }

// //         .ec-grid{
// //           display:grid;
// //           grid-template-columns:minmax(290px,355px) minmax(220px,250px) minmax(280px,1fr);
// //           gap:16px;
// //           align-items:stretch;
// //         }

// //         .ec-form,
// //         .ec-stats,
// //         .ec-promo{
// //           min-width:0;
// //         }

// //         .ec-form,
// //         .ec-stats__grid,
// //         .ec-promo{
// //           background:rgba(10,8,20,.20);
// //           border:1px solid rgba(255,255,255,.14);
// //           box-shadow:0 12px 28px rgba(0,0,0,.14);
// //           backdrop-filter:blur(4px);
// //         }

// //         .ec-form{
// //           padding:14px;
// //         }

// //         .ec-form__top{
// //           margin-bottom:8px;
// //         }

// //         .ec-form__top--small{
// //           margin-bottom:6px;
// //         }

// //         .ec-panel-title{
// //           margin:0 0 4px;
// //           font-size:16px;
// //           line-height:1.2;
// //           font-weight:700;
// //           color:#fff;
// //         }

// //         .ec-panel-sub{
// //           margin:0;
// //           font-size:11px;
// //           line-height:1.45;
// //           color:rgba(255,255,255,.76);
// //         }

// //         .ec-divider{
// //           height:1px;
// //           background:rgba(255,255,255,.14);
// //           margin:8px 0;
// //         }

// //         .ec-field{
// //           margin-bottom:8px;
// //         }

// //         .ec-field label{
// //           font-size:10px;
// //           font-weight:700;
// //           display:block;
// //           margin-bottom:4px;
// //           letter-spacing:.08em;
// //           text-transform:uppercase;
// //           color:rgba(255,255,255,.9);
// //         }

// //         .ec-field input,
// //         .ec-field select{
// //           width:100%;
// //           min-height:38px;
// //           background:rgba(255,255,255,.08);
// //           border:1px solid rgba(255,255,255,.18);
// //           color:#fff;
// //           padding:0 10px;
// //           font-size:12px;
// //           border-radius:0;
// //           outline:none;
// //           box-sizing:border-box;
// //           transition:border-color .2s ease, background .2s ease;
// //         }

// //         .ec-field input::placeholder{
// //           color:rgba(255,255,255,.55);
// //         }

// //         .ec-field select option{
// //           color:#000;
// //           background:#ffffff;
// //         }

// //         .ec-field input:focus,
// //         .ec-field select:focus{
// //           border-color:#ffd55a;
// //           background:rgba(255,255,255,.11);
// //         }

// //         .ec-row{
// //           display:grid;
// //           grid-template-columns:1fr 1fr;
// //           gap:10px;
// //         }

// //         .ec-field--hidden{
// //           display:none;
// //         }

// //         .ec-btn{
// //           width:100%;
// //           min-height:40px;
// //           background:linear-gradient(120deg,#ffd55a,#ffb13b);
// //           color:#3a2145;
// //           border:none;
// //           font-size:12px;
// //           font-weight:800;
// //           cursor:pointer;
// //           margin-top:2px;
// //           border-radius:0;
// //           letter-spacing:.02em;
// //           transition:transform .2s ease, filter .2s ease;
// //         }

// //         .ec-btn:hover{
// //           filter:brightness(1.04);
// //           transform:translateY(-1px);
// //         }

// //         .ec-note{
// //           margin-top:8px;
// //           font-size:10px;
// //           line-height:1.4;
// //           color:rgba(255,255,255,.72);
// //         }

// //         .ec-stats{
// //           display:flex;
// //           flex-direction:column;
// //           justify-content:stretch;
// //         }

// //         .ec-stats__grid{
// //           display:grid;
// //           grid-template-columns:1fr;
// //           gap:10px;
// //           padding:12px;
// //           height:100%;
// //         }

// //         .ec-card{
// //           background:rgba(255,255,255,.07);
// //           border:1px solid rgba(255,255,255,.12);
// //           padding:12px 10px;
// //           text-align:center;
// //           display:flex;
// //           flex-direction:column;
// //           justify-content:center;
// //           min-height:88px;
// //         }

// //         .ec-card--highlight{
// //           background:linear-gradient(180deg,rgba(255,255,255,.10),rgba(255,255,255,.06));
// //         }

// //         .ec-label{
// //           font-size:10px;
// //           font-weight:700;
// //           letter-spacing:.08em;
// //           text-transform:uppercase;
// //           color:rgba(255,255,255,.78);
// //           margin-bottom:6px;
// //           display:block;
// //         }

// //         .ec-value{
// //           font-size:clamp(18px,1.8vw,24px);
// //           line-height:1.1;
// //           font-weight:800;
// //           letter-spacing:-.02em;
// //           color:#fff;
// //           word-break:break-word;
// //         }

// //         .ec-promo{
// //           display:flex;
// //           flex-direction:column;
// //           overflow:hidden;
// //           min-height:0;
// //         }

// //         .ec-promo__media{
// //           background:rgba(255,255,255,.04);
// //           flex:1 1 auto;
// //           display:flex;
// //           align-items:center;
// //           justify-content:center;
// //           min-height:0;
// //           padding:10px;
// //         }

// //         .ec-promo img{
// //           width:100%;
// //           height:100%;
// //           max-height:100%;
// //           object-fit:contain;
// //           display:block;
// //         }

// //         .ec-promo__content{
// //           padding:12px 14px;
// //           display:flex;
// //           flex-direction:column;
// //           gap:6px;
// //         }

// //         .ec-promo__content h3{
// //           margin:0;
// //           font-size:clamp(16px,1.6vw,22px);
// //           line-height:1.15;
// //           font-weight:700;
// //           color:#fff;
// //         }

// //         .ec-promo__content p{
// //           margin:0;
// //           font-size:12px;
// //           line-height:1.45;
// //           color:rgba(255,255,255,.82);
// //         }

// //         .ec-cta{
// //           display:inline-flex;
// //           align-items:center;
// //           justify-content:center;
// //           align-self:flex-start;
// //           min-height:36px;
// //           padding:0 14px;
// //           text-decoration:none;
// //           font-size:11px;
// //           font-weight:700;
// //           border:1px solid rgba(255,255,255,.2);
// //           background:#542757;
// //           color:#fff;
// //           transition:background .2s ease, transform .2s ease;
// //         }

// //         .ec-cta:hover{
// //           background:#9b1f6c;
// //           transform:translateY(-1px);
// //         }

// //         @media (min-width:1025px){
// //           .ec-grid{
// //             min-height:calc(100vh - 110px);
// //           }

// //           .ec-promo__media{
// //             max-height:calc(100vh - 230px);
// //           }
// //         }

// //         @media (max-width:1024px){
// //           .section-inner{
// //             padding:28px 16px;
// //           }

// //           .ec-head{
// //             margin-bottom:18px;
// //           }

// //           .ec-head h2{
// //             font-size:28px;
// //           }

// //           .ec-head p{
// //             font-size:14px;
// //             line-height:1.6;
// //           }

// //           .ec-grid{
// //             grid-template-columns:1fr 1fr;
// //             gap:16px;
// //           }

// //           .ec-promo{
// //             grid-column:1 / -1;
// //             flex-direction:row;
// //             align-items:stretch;
// //           }

// //           .ec-promo__media,
// //           .ec-promo__content{
// //             width:50%;
// //           }

// //           .ec-promo__content{
// //             justify-content:center;
// //           }
// //         }

// //         @media (max-width:767px){
// //           .section-inner{
// //             padding:32px 12px;
// //           }

// //           .ec-head{
// //             margin-bottom:22px;
// //           }

// //           .ec-head h2{
// //             font-size:26px;
// //           }

// //           .ec-head p{
// //             font-size:14px;
// //             line-height:1.6;
// //           }

// //           .ec-grid{
// //             grid-template-columns:1fr;
// //             gap:14px;
// //           }

// //           .ec-form{
// //             padding:14px;
// //           }

// //           .ec-panel-title{
// //             font-size:16px;
// //           }

// //           .ec-panel-sub{
// //             font-size:12px;
// //             line-height:1.55;
// //           }

// //           .ec-row{
// //             grid-template-columns:1fr 1fr;
// //             gap:10px;
// //           }

// //           .ec-field{
// //             margin-bottom:10px;
// //           }

// //           .ec-field label{
// //             font-size:10px;
// //             margin-bottom:5px;
// //           }

// //           .ec-field input,
// //           .ec-field select{
// //             min-height:42px;
// //             font-size:12px;
// //             padding:0 10px;
// //           }

// //           .ec-stats__grid{
// //             grid-template-columns:repeat(2,minmax(0,1fr));
// //             gap:10px;
// //             padding:12px;
// //           }

// //           .ec-card{
// //             min-height:98px;
// //             padding:14px 10px;
// //           }

// //           .ec-card--wide{
// //             grid-column:1 / -1;
// //           }

// //           .ec-label{
// //             font-size:10px;
// //             margin-bottom:6px;
// //           }

// //           .ec-value{
// //             font-size:18px;
// //           }

// //           .ec-promo{
// //             flex-direction:column;
// //           }

// //           .ec-promo__media,
// //           .ec-promo__content{
// //             width:100%;
// //           }

// //           .ec-promo__content{
// //             padding:14px;
// //             gap:8px;
// //           }

// //           .ec-promo__content h3{
// //             font-size:18px;
// //           }

// //           .ec-promo__content p{
// //             font-size:13px;
// //             line-height:1.6;
// //           }

// //           .ec-cta{
// //             width:100%;
// //             min-height:42px;
// //             font-size:12px;
// //           }

// //           .ec-btn{
// //             min-height:44px;
// //             font-size:12px;
// //           }

// //           .ec-note{
// //             font-size:11px;
// //           }
// //         }

// //         @media (max-width:480px){
// //           .section-inner{
// //             padding:28px 10px;
// //           }

// //           .ec-head__eyebrow{
// //             font-size:10px;
// //           }

// //           .ec-head h2{
// //             font-size:23px;
// //           }

// //           .ec-row{
// //             grid-template-columns:1fr;
// //           }

// //           .ec-stats__grid{
// //             grid-template-columns:repeat(2,minmax(0,1fr));
// //             gap:8px;
// //             padding:10px;
// //           }

// //           .ec-card{
// //             min-height:92px;
// //             padding:12px 8px;
// //           }

// //           .ec-value{
// //             font-size:16px;
// //           }

// //           .ec-label{
// //             font-size:9px;
// //           }

// //           .ec-promo__content h3{
// //             font-size:16px;
// //           }

// //           .ec-promo__content p{
// //             font-size:12px;
// //           }
// //         }
// //       `}</style>
// // <Navbar/>
// //       <section id="hlc-savings-section" className="full-bg-section bg-brand">
// //         <div className="section-inner">
// //           {/* Heading */}
// //           <header className="ec-head">
// //             <span className="ec-head__eyebrow">Savings Calculator</span>
// //             <h2>See Your Lighting Savings</h2>
// //             <p>
// //               HLC LEDs wattage kam, brightness zyada. Abhi estimate karein kitni
// //               monthly aur yearly bachhat ho sakti hai.
// //             </p>
// //           </header>

// //           {/* MAIN GRID */}
// //           <div className="ec-grid">
// //             {/* LEFT FORM */}
// //             <aside className="ec-form">
// //               <div className="ec-form__top">
// //                 <h3 className="ec-panel-title">Select Your Product</h3>
// //                 <p className="ec-panel-sub">
// //                   Category, product aur watt/model select karein. Selected
// //                   wattage automatically calculation men use hoga.
// //                 </p>
// //               </div>

// //               {/* SUB CATEGORY */}
// //               <div className="ec-field">
// //                 <label htmlFor="ec_subcategory">Select Sub Category</label>
// //                 <select
// //                   id="ec_subcategory"
// //                   value={subCategory}
// //                   onChange={handleSubChange}
// //                 >
// //                   <option value="">Choose a sub category</option>
// //                   {subList.map((sub) => (
// //                     <option key={sub} value={sub}>
// //                       {sub}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>

// //               {/* PRODUCT */}
// //               <div
// //                 className={`ec-field ${
// //                   !subCategory ? "ec-field--hidden" : ""
// //                 }`}
// //                 id="ec_productWrapper"
// //               >
// //                 <label htmlFor="ec_product">Select Product</label>
// //                 <select
// //                   id="ec_product"
// //                   value={product}
// //                   onChange={handleProductChange}
// //                 >
// //                   <option value="">Choose a product</option>
// //                   {productsList.map((p) => (
// //                     <option key={p} value={p}>
// //                       {p}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>

// //               {/* WATT / MODEL */}
// //               <div
// //                 className={`ec-field ${
// //                   !product ? "ec-field--hidden" : ""
// //                 }`}
// //                 id="ec_wattageWrapper"
// //               >
// //                 <label htmlFor="ec_wattage">Select Watt / Model</label>
// //                 <select
// //                   id="ec_wattage"
// //                   value={wattage}
// //                   onChange={handleWattChange}
// //                 >
// //                   <option value="">Choose watt / model</option>
// //                   {wattList.map((w) => (
// //                     <option key={w} value={w}>
// //                       {w}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>

// //               <div className="ec-divider"></div>

// //               <div className="ec-form__top ec-form__top--small">
// //                 <h3 className="ec-panel-title">Usage Details</h3>
// //               </div>

// //               <div className="ec-field">
// //                 <label htmlFor="ec_currentW">Current Bulb Wattage (W)</label>
// //                 <input
// //                   id="ec_currentW"
// //                   type="number"
// //                   value={currentW}
// //                   min="1"
// //                   onChange={(e) => setCurrentW(+e.target.value)}
// //                 />
// //               </div>

// //               <div className="ec-row">
// //                 <div className="ec-field">
// //                   <label htmlFor="ec_hours">Daily Usage (hours)</label>
// //                   <input
// //                     id="ec_hours"
// //                     type="number"
// //                     value={hours}
// //                     min="1"
// //                     onChange={(e) => setHours(+e.target.value)}
// //                   />
// //                 </div>

// //                 <div className="ec-field">
// //                   <label htmlFor="ec_bulbs">Bulbs Count</label>
// //                   <input
// //                     id="ec_bulbs"
// //                     type="number"
// //                     value={bulbs}
// //                     min="1"
// //                     onChange={(e) => setBulbs(+e.target.value)}
// //                   />
// //                 </div>
// //               </div>

// //               <div className="ec-field">
// //                 <label htmlFor="ec_rate">Electricity Cost (PKR / kWh)</label>
// //                 <input
// //                   id="ec_rate"
// //                   type="number"
// //                   value={rate}
// //                   min="1"
// //                   onChange={(e) => setRate(+e.target.value)}
// //                 />
// //               </div>

// //               <button
// //                 id="ec_calc"
// //                 className="ec-btn"
// //                 type="button"
// //                 onClick={calculateSavings}
// //               >
// //                 Calculate Savings
// //               </button>

// //               <p className="ec-note">
// //                 Tip: Values ko apne ghar, shop ya office ke hisaab se adjust
// //                 karein.
// //               </p>
// //             </aside>

// //             {/* MIDDLE STATS */}
// //             <section className="ec-stats" aria-label="Savings Results">
// //               <div className="ec-stats__grid">
// //                 <div className="ec-card ec-card--highlight">
// //                   <span className="ec-label">Monthly Saving</span>
// //                   <strong id="ec_month" className="ec-value">
// //                     {monthlySaving}
// //                   </strong>
// //                 </div>

// //                 <div className="ec-card ec-card--highlight">
// //                   <span className="ec-label">Yearly Saving</span>
// //                   <strong id="ec_year" className="ec-value">
// //                     {yearlySaving}
// //                   </strong>
// //                 </div>

// //                 <div className="ec-card ec-card--wide">
// //                   <span className="ec-label">Energy Reduced</span>
// //                   <strong id="ec_energy" className="ec-value">
// //                     {energyReduced}
// //                   </strong>
// //                 </div>
// //               </div>
// //             </section>

// //             {/* RIGHT IMAGE + CTA */}
// //             <figure className="ec-promo">
// //               <div className="ec-promo__media">
// //                 <img
// //                   id="ec_productImage"
// //                   src={selectedItem?.image || demoImage}
// //                   alt={
// //                     selectedItem
// //                       ? `${selectedItem.product} ${selectedItem.modelLabel}`
// //                       : "HLC LED Product"
// //                   }
// //                 />
// //               </div>

// //               <figcaption className="ec-promo__content">
// //                 <h3>Switch to Efficient HLC LEDs</h3>
// //                 <p>
// //                   Choose better brightness with lower electricity consumption
// //                   for homes, offices and commercial projects.
// //                 </p>
// //                 <Link to="/shop" className="ec-cta">
// //                   Shop Recommended LEDs
// //                 </Link>
// //               </figcaption>
// //             </figure>
// //           </div>
// //         </div>
// //       </section>

// //       <HlcFooter/>
// //     </>
// //   );
// // }

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import { db } from '../firebase';
// import { ref as dbRef, onValue } from 'firebase/database';
// import Navbar from "../components/Navbar";
// import HlcFooter from "../components/HlcFooter";
// // Helper: extract wattage number from a label like "12W Cool White"
// function parseWatt(label) {
//   const match = /([\d.]+)\s*W/i.exec(String(label));
//   return match ? parseFloat(match[1]) : null;
// }

// // Helper: get first available image from a product
// function getProductImage(product) {
//   if (product.images) {
//     if (Array.isArray(product.images) && product.images.length > 0) return product.images[0];
//     if (typeof product.images === 'object') {
//       const vals = Object.values(product.images);
//       if (vals.length > 0) return vals[0];
//     }
//   }
//   return product.image || null;
// }

// export default function HLCSavingsCalculator() {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [selectedSub, setSelectedSub] = useState("");
//   const [selectedProduct, setSelectedProduct] = useState("");
//   const [selectedModel, setSelectedModel] = useState("");
//   const [currentW, setCurrentW] = useState("");
//   const [hours, setHours] = useState("");
//   const [bulbs, setBulbs] = useState("");
//   const [rate, setRate] = useState("65");
//   const [results, setResults] = useState({ month: null, year: null, energy: null });

//   const monthRef = useRef(null);
//   const yearRef = useRef(null);

//   /* ── Fetch from Firebase ── */
//   useEffect(() => {
//     const productsRef = dbRef(db, 'products');
//     const unsubscribe = onValue(productsRef, (snapshot) => {
//       const data = snapshot.val();
//       const parsed = data
//         ? Object.keys(data).map((key) => ({ id: key, ...data[key] }))
//         : [];
//       setProducts(parsed);
//       setLoading(false);
//     });
//     return () => unsubscribe();
//   }, []);

//   /* ── Build cascading tree: category → productName → [wattModels] ── */
//   const TREE = useMemo(() => {
//     const tree = {};
//     products.forEach((item) => {
//       const main = item.category || 'Uncategorized';
//       const prod = item.name || '';
//       const watts = Array.isArray(item.wattColourModel) ? item.wattColourModel : [];
//       if (!tree[main]) tree[main] = {};
//       if (!tree[main][prod]) tree[main][prod] = { models: new Set(), items: [] };
//       watts.forEach((w) => tree[main][prod].models.add(w));
//       tree[main][prod].items.push(item);
//     });

//     // Sort and convert Sets to arrays
//     const result = {};
//     Object.keys(tree).sort().forEach((main) => {
//       result[main] = {};
//       Object.keys(tree[main]).sort().forEach((prod) => {
//         result[main][prod] = {
//           models: [...tree[main][prod].models].sort(),
//           items: tree[main][prod].items,
//         };
//       });
//     });
//     return result;
//   }, [products]);

//   const subList = Object.keys(TREE);
//   const productList = selectedSub ? Object.keys(TREE[selectedSub] || {}) : [];
//   const modelList = selectedSub && selectedProduct
//     ? TREE[selectedSub]?.[selectedProduct]?.models || []
//     : [];

//   /* ── Derive product image: pick from matched product items ── */
//   const promoImage = useMemo(() => {
//     if (selectedSub && selectedProduct) {
//       const items = TREE[selectedSub]?.[selectedProduct]?.items || [];
//       for (const item of items) {
//         const img = getProductImage(item);
//         if (img) return img;
//       }
//     }
//     return "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Section-10-saving.png";
//   }, [selectedSub, selectedProduct, TREE]);

//   const selectedWatt = selectedModel ? parseWatt(selectedModel) : null;

//   /* ── Auto-fill current wattage when model selected ── */
//   useEffect(() => {
//     if (selectedWatt !== null) {
//       setCurrentW(String(selectedWatt));
//     } else {
//       setCurrentW("");
//     }
//     setResults({ month: null, year: null, energy: null });
//   }, [selectedModel]);

//   function animateCurrency(el, end) {
//     const duration = 500;
//     const startTime = performance.now();
//     function tick(now) {
//       const p = Math.min((now - startTime) / duration, 1);
//       const val = Math.round(end * p);
//       el.textContent = "PKR " + val.toLocaleString();
//       if (p < 1) requestAnimationFrame(tick);
//     }
//     requestAnimationFrame(tick);
//   }

//   function handleCalculate() {
//     if (!selectedSub) { alert("Please select product category first."); return; }
//     if (!selectedProduct) { alert("Please select product."); return; }
//     if (!selectedModel) { alert("Please select watt / model."); return; }
//     if (selectedWatt === null) { alert("This model does not have a defined wattage for the calculator."); return; }
//     if (!currentW || !hours || !bulbs || !rate) { alert("Please fill all fields."); return; }

//     const W = +currentW;
//     const hrs = +hours;
//     const b = +bulbs;
//     const r = +rate;
//     const LED = selectedWatt;

//     const cur = (W * b * hrs * 30) / 1000;
//     const led = (LED * b * hrs * 30) / 1000;
//     const save = Math.max(cur - led, 0);

//     const monthVal = Math.round(save * r);
//     const yearVal = Math.round(save * r * 12);
//     const energyVal = save.toFixed(1) + " kWh / month";

//     setResults({ month: monthVal, year: yearVal, energy: energyVal });

//     setTimeout(() => {
//       if (monthRef.current) animateCurrency(monthRef.current, monthVal);
//       if (yearRef.current) animateCurrency(yearRef.current, yearVal);
//     }, 0);
//   }

//   function handleSubChange(e) {
//     setSelectedSub(e.target.value);
//     setSelectedProduct("");
//     setSelectedModel("");
//     setCurrentW("");
//     setResults({ month: null, year: null, energy: null });
//   }

//   function handleProductChange(e) {
//     setSelectedProduct(e.target.value);
//     setSelectedModel("");
//     setCurrentW("");
//     setResults({ month: null, year: null, energy: null });
//   }

//   function handleModelChange(e) {
//     setSelectedModel(e.target.value);
//   }

//   return (
//     <>
//     <Navbar/>

//       <style>{`
//         .full-bg-section {
//           position: relative;
//           left: 50%;
//           right: 50%;
//           margin-left: -50vw;
//           margin-right: -50vw;
//           width: 100vw;
//           overflow: hidden;
//           padding: 0;
//            margin-top:60px

//         }
//         .bg-brand {
//           background: linear-gradient(135deg, #9b1f6c 0%, #542757 45%, #35335b 100%);
//           color: #fff;
//         }
//         .section-inner {
//           max-width: 1200px;
//           margin: auto;
//           padding: 18px 18px 18px;
//           box-sizing: border-box;
//           font-family: "Open Sans", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
//         }
//         #hlc-savings-section { min-height: auto; }
//         @media (min-width: 1025px) {
//           #hlc-savings-section { min-height: 100vh; display: flex; align-items: center; }
//           .section-inner { width: 100%; padding: 12px 18px; }
//         }
//         .ec-head { text-align: center; margin-bottom: 12px; }
//         .ec-head__eyebrow {
//           display: inline-block; margin: 0 0 4px; font-size: 10px; font-weight: 700;
//           letter-spacing: .16em; text-transform: uppercase; color: rgba(255,255,255,.72);
//         }
//         .ec-head h2 {
//           font-size: clamp(22px, 2.9vw, 30px); line-height: 1.05; margin: 0 0 4px;
//           font-weight: 800; letter-spacing: -.02em;
//         }
//         .ec-head p {
//           max-width: 760px; margin: 0 auto; font-size: 12px;
//           line-height: 1.45; color: rgba(255,255,255,.84);
//         }
//         .ec-grid {
//           display: grid;
//           grid-template-columns: minmax(290px, 355px) minmax(220px, 250px) minmax(280px, 1fr);
//           gap: 16px; align-items: stretch;
//         }
//         .ec-form, .ec-stats, .ec-promo { min-width: 0; }
//         .ec-form, .ec-stats__grid, .ec-promo {
//           background: rgba(10,8,20,.20); border: 1px solid rgba(255,255,255,.14);
//           box-shadow: 0 12px 28px rgba(0,0,0,.14); backdrop-filter: blur(4px);
//         }
//         .ec-form { padding: 14px; }
//         .ec-form__top { margin-bottom: 8px; }
//         .ec-form__top--small { margin-bottom: 6px; }
//         .ec-panel-title { margin: 0 0 4px; font-size: 16px; line-height: 1.2; font-weight: 700; color: #fff; }
//         .ec-panel-sub { margin: 0; font-size: 11px; line-height: 1.45; color: rgba(255,255,255,.76); }
//         .ec-divider { height: 1px; background: rgba(255,255,255,.14); margin: 8px 0; }
//         .ec-field { margin-bottom: 8px; }
//         .ec-field label {
//           font-size: 10px; font-weight: 700; display: block; margin-bottom: 4px;
//           letter-spacing: .08em; text-transform: uppercase; color: rgba(255,255,255,.9);
//         }
//         .ec-field input, .ec-field select {
//           width: 100%; min-height: 38px; background: rgba(255,255,255,.08);
//           border: 1px solid rgba(255,255,255,.18); color: #fff; padding: 0 10px;
//           font-size: 12px; border-radius: 0; outline: none; box-sizing: border-box;
//           transition: border-color .2s ease, background .2s ease;
//         }
//         .ec-field input::placeholder { color: rgba(255,255,255,.55); }
//         .ec-field select option { color: #000; background: #ffffff; }
//         .ec-field input:focus, .ec-field select:focus {
//           border-color: #ffd55a; background: rgba(255,255,255,.11);
//         }
//         .ec-row { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
//         .ec-row--product { align-items: end; }
//         .ec-row--product .ec-field { margin-bottom: 8px; }
//         .ec-field--hidden { display: none; }
//         .ec-btn {
//           width: 100%; min-height: 40px;
//           background: linear-gradient(120deg, #ffd55a, #ffb13b);
//           color: #3a2145; border: none; font-size: 12px; font-weight: 800;
//           cursor: pointer; margin-top: 2px; border-radius: 0; letter-spacing: .02em;
//           transition: transform .2s ease, filter .2s ease;
//         }
//         .ec-btn:hover { filter: brightness(1.04); transform: translateY(-1px); }
//         .ec-note { margin-top: 8px; font-size: 10px; line-height: 1.4; color: rgba(255,255,255,.72); }
//         .ec-stats { display: flex; flex-direction: column; justify-content: stretch; }
//         .ec-stats__grid {
//           display: grid; grid-template-columns: 1fr; gap: 10px;
//           padding: 12px; height: 100%;
//         }
//         .ec-card {
//           background: rgba(255,255,255,.07); border: 1px solid rgba(255,255,255,.12);
//           padding: 12px 10px; text-align: center; display: flex;
//           flex-direction: column; justify-content: center; min-height: 88px;
//         }
//         .ec-card--highlight {
//           background: linear-gradient(180deg, rgba(255,255,255,.10), rgba(255,255,255,.06));
//         }
//         .ec-label {
//           font-size: 10px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase;
//           color: rgba(255,255,255,.78); margin-bottom: 6px; display: block;
//         }
//         .ec-value {
//           font-size: clamp(18px, 1.8vw, 24px); line-height: 1.1; font-weight: 800;
//           letter-spacing: -.02em; color: #fff; word-break: break-word;
//         }
//         .ec-promo { display: flex; flex-direction: column; overflow: hidden; min-height: 0; }
//         .ec-promo__media {
//           background: rgba(255,255,255,.04); flex: 1 1 auto;
//           display: flex; align-items: center; justify-content: center;
//           min-height: 0; padding: 10px;
//         }
//         .ec-promo img { width: 100%; height: 100%; max-height: 100%; object-fit: contain; display: block; transition: opacity .3s ease; }
//         .ec-promo__content { padding: 12px 14px; display: flex; flex-direction: column; gap: 6px; }
//         .ec-promo__content h3 {
//           margin: 0; font-size: clamp(16px, 1.6vw, 22px); line-height: 1.15; font-weight: 700; color: #fff;
//         }
//         .ec-promo__content p { margin: 0; font-size: 12px; line-height: 1.45; color: rgba(255,255,255,.82); }
//         .ec-cta {
//           display: inline-flex; align-items: center; justify-content: center;
//           align-self: flex-start; min-height: 36px; padding: 0 14px; text-decoration: none;
//           font-size: 11px; font-weight: 700; border: 1px solid rgba(255,255,255,.2);
//           background: #542757; color: #fff; transition: background .2s ease, transform .2s ease;
//         }
//         .ec-cta:hover { background: #9b1f6c; transform: translateY(-1px); }
//         .ec-loading {
//           display: flex; align-items: center; justify-content: center;
//           gap: 8px; padding: 6px 0; font-size: 11px; color: rgba(255,255,255,.6);
//         }
//         .ec-spinner {
//           width: 14px; height: 14px; border: 2px solid rgba(255,255,255,.2);
//           border-top-color: #ffd55a; border-radius: 50%; animation: spin .7s linear infinite;
//         }
//         @keyframes spin { to { transform: rotate(360deg); } }
//         @media (min-width: 1025px) {
//           .ec-grid { min-height: calc(100vh - 110px); }
//           .ec-promo__media { max-height: calc(100vh - 230px); }
//         }
//         @media (max-width: 1024px) {
//           .section-inner { padding: 28px 16px; }
//           .ec-head { margin-bottom: 18px; }
//           .ec-head h2 { font-size: 28px; }
//           .ec-head p { font-size: 14px; line-height: 1.6; }
//           .ec-grid { grid-template-columns: 1fr 1fr; gap: 16px; }
//           .ec-promo { grid-column: 1 / -1; flex-direction: row; align-items: stretch; }
//           .ec-promo__media, .ec-promo__content { width: 50%; }
//           .ec-promo__content { justify-content: center; }
//         }
//         @media (max-width: 767px) {
//           .section-inner { padding: 32px 12px; }
//           .ec-head { margin-bottom: 22px; }
//           .ec-head h2 { font-size: 26px; }
//           .ec-head p { font-size: 14px; line-height: 1.6; }
//           .ec-grid { grid-template-columns: 1fr; gap: 14px; }
//           .ec-form { padding: 14px; }
//           .ec-panel-title { font-size: 16px; }
//           .ec-panel-sub { font-size: 12px; line-height: 1.55; }
//           .ec-row { grid-template-columns: 1fr 1fr; gap: 10px; }
//           .ec-field { margin-bottom: 10px; }
//           .ec-field label { font-size: 10px; margin-bottom: 5px; }
//           .ec-field input, .ec-field select { min-height: 42px; font-size: 12px; padding: 0 10px; }
//           .ec-stats__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; padding: 12px; }
//           .ec-card { min-height: 98px; padding: 14px 10px; }
//           .ec-card--wide { grid-column: 1 / -1; }
//           .ec-label { font-size: 10px; margin-bottom: 6px; }
//           .ec-value { font-size: 18px; }
//           .ec-promo { flex-direction: column; }
//           .ec-promo__media, .ec-promo__content { width: 100%; }
//           .ec-promo__content { padding: 14px; gap: 8px; }
//           .ec-promo__content h3 { font-size: 18px; }
//           .ec-promo__content p { font-size: 13px; line-height: 1.6; }
//           .ec-cta { width: 100%; min-height: 42px; font-size: 12px; }
//           .ec-btn { min-height: 44px; font-size: 12px; }
//           .ec-note { font-size: 11px; }
//         }
//         @media (max-width: 480px) {
//           .section-inner { padding: 28px 10px; }
//           .ec-head__eyebrow { font-size: 10px; }
//           .ec-head h2 { font-size: 23px; }
//           .ec-row { grid-template-columns: 1fr; }
//           .ec-stats__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; padding: 10px; }
//           .ec-card { min-height: 92px; padding: 12px 8px; }
//           .ec-value { font-size: 16px; }
//           .ec-label { font-size: 9px; }
//           .ec-promo__content h3 { font-size: 16px; }
//           .ec-promo__content p { font-size: 12px; }
//         }
//       `}</style>

//       <section id="hlc-savings-section" className="full-bg-section bg-brand">
//         <div className="section-inner">

//           {/* Heading */}
//           <header className="ec-head">
//             <span className="ec-head__eyebrow">Savings Calculator</span>
//             <h2>See Your Lighting Savings</h2>
//             <p>HLC LEDs wattage kam, brightness zyada. Abhi estimate karein kitni monthly aur yearly bachhat ho sakti hai.</p>
//           </header>

//           {/* Main Grid */}
//           <div className="ec-grid">

//             {/* LEFT FORM */}
//             <aside className="ec-form">
//               <div className="ec-form__top">
//                 <h3 className="ec-panel-title">Select Your Product</h3>
//                 <p className="ec-panel-sub">Category, product aur watt/model select karein. Selected wattage automatically calculation men use hoga.</p>
//               </div>

//               {loading ? (
//                 <div className="ec-loading">
//                   <div className="ec-spinner" />
//                   <span>Loading products…</span>
//                 </div>
//               ) : (
//                 <>
//                   <div className="ec-field">
//                     <label>Select Product Category</label>
//                     <select value={selectedSub} onChange={handleSubChange}>
//                       <option value="">Choose a product category</option>
//                       {subList.map((sub) => (
//                         <option key={sub} value={sub}>{sub}</option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="ec-row ec-row--product">
//                     <div className={`ec-field ${!selectedSub ? "ec-field--hidden" : ""}`}>
//                       <label>Select Product</label>
//                       <select value={selectedProduct} onChange={handleProductChange}>
//                         <option value="">Choose a product</option>
//                         {productList.map((p) => (
//                           <option key={p} value={p}>{p}</option>
//                         ))}
//                       </select>
//                     </div>

//                     <div className={`ec-field ${!selectedProduct ? "ec-field--hidden" : ""}`}>
//                       <label>Select Watt / Model</label>
//                       <select value={selectedModel} onChange={handleModelChange}>
//                         <option value="">Choose watt / model</option>
//                         {modelList.map((model) => (
//                           <option key={model} value={model}>{model}</option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </>
//               )}

//               <div className="ec-divider"></div>

//               <div className="ec-form__top ec-form__top--small">
//                 <h3 className="ec-panel-title">Current Usage Details</h3>
//               </div>

//               <div className="ec-field">
//                 <label>Current Bulb Wattage (W)</label>
//                 <input
//                   type="number"
//                   value={currentW}
//                   min="1"
//                   placeholder="e.g. 60"
//                   onChange={(e) => setCurrentW(e.target.value)}
//                 />
//               </div>

//               <div className="ec-row">
//                 <div className="ec-field">
//                   <label>Daily Usage (hours)</label>
//                   <input
//                     type="number"
//                     value={hours}
//                     min="1"
//                     placeholder="e.g. 8"
//                     onChange={(e) => setHours(e.target.value)}
//                   />
//                 </div>
//                 <div className="ec-field">
//                   <label>Bulbs Count</label>
//                   <input
//                     type="number"
//                     value={bulbs}
//                     min="1"
//                     placeholder="e.g. 5"
//                     onChange={(e) => setBulbs(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="ec-field">
//                 <label>Electricity Cost (PKR / kWh)</label>
//                 <input
//                   type="number"
//                   value={rate}
//                   min="1"
//                   onChange={(e) => setRate(e.target.value)}
//                 />
//               </div>

//               <button className="ec-btn" type="button" onClick={handleCalculate}>
//                 Calculate Savings
//               </button>
//               <p className="ec-note">Tip: Values ko apne ghar, shop ya office ke hisaab se adjust karein.</p>
//             </aside>

//             {/* MIDDLE STATS */}
//             <section className="ec-stats" aria-label="Savings Results">
//               <div className="ec-stats__grid">
//                 <div className="ec-card ec-card--highlight">
//                   <span className="ec-label">Monthly Saving</span>
//                   <strong ref={monthRef} className="ec-value">
//                     {results.month !== null ? `PKR ${results.month.toLocaleString()}` : "PKR —"}
//                   </strong>
//                 </div>
//                 <div className="ec-card ec-card--highlight">
//                   <span className="ec-label">Yearly Saving</span>
//                   <strong ref={yearRef} className="ec-value">
//                     {results.year !== null ? `PKR ${results.year.toLocaleString()}` : "PKR —"}
//                   </strong>
//                 </div>
//                 <div className="ec-card ec-card--wide">
//                   <span className="ec-label">Energy Reduced</span>
//                   <strong className="ec-value">
//                     {results.energy !== null ? results.energy : "— kWh / month"}
//                   </strong>
//                 </div>
//               </div>
//             </section>

//             {/* RIGHT PROMO */}
//             <figure className="ec-promo">
//               <div className="ec-promo__media">
//                 <img
//                   src={promoImage}
//                   alt={
//                     selectedProduct
//                       ? `${selectedProduct} ${selectedModel}`
//                       : "HLC LED Product"
//                   }
//                 />
//               </div>
//               <figcaption className="ec-promo__content">
//                 <h3>
//                   {selectedProduct
//                     ? selectedProduct
//                     : "Switch to Efficient HLC LEDs"}
//                 </h3>
//                 <p>
//                   {selectedModel
//                     ? `Model: ${selectedModel} — Choose better brightness with lower electricity consumption.`
//                     : "Choose better brightness with lower electricity consumption for homes, offices and commercial projects."}
//                 </p>
//                 <a href="#shop" className="ec-cta">Shop Recommended LEDs</a>
//               </figcaption>
//             </figure>

//           </div>
//         </div>
//       </section>
//             <HlcFooter/>

//     </>
//   );
// }

import React from "react";
import Navbar from "../components/Navbar";
import HlcFooter from "../components/HlcFooter";
import HLCSavingsCalculator from "./HlcCalculator";

/* Standalone /calculator route. The actual calculator experience lives
   in HlcCalculator.js (also rendered on the home page) — this file is
   just the Navbar/Footer wrapper plus the top offset needed to clear
   the fixed navbar when the calculator isn't preceded by other page
   content, as it is on the home page. */
export default function Calculator() {
  return (
    <>
      <Navbar />
      <div style={{ marginTop: 55 }}>
        <HLCSavingsCalculator />
      </div>
      <HlcFooter />
    </>
  );
}
